import React from 'react';
import { List, Datagrid, TextField, EditButton, ShowButton } from 'react-admin';

export const NearbyList = (props) => (
    <List {...props}>
        <Datagrid>
            <TextField source="name" />
            <ShowButton />
            <EditButton />
        </Datagrid>
    </List>
);


// WEBPACK FOOTER //
// ./src/components/nearby/NearbyList.js